import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "tw-text-left" }
const _hoisted_2 = { class: "tw-flex tw-items-center tw-justify-between tw-gap-3" }
const _hoisted_3 = { class: "tw-mt-3 tw-grid tw-grid-cols-1 sm:tw-grid-cols-4 tw-gap-2" }
const _hoisted_4 = { class: "tw-rounded-xl tw-border tw-border-slate-200/70 tw-bg-white/50 tw-p-2.5" }
const _hoisted_5 = { class: "tw-mt-0.5 tw-text-sm tw-font-medium tw-text-slate-900" }
const _hoisted_6 = {
  key: 0,
  class: "tw-rounded-xl tw-border tw-border-slate-200/70 tw-bg-white/50 tw-p-2.5"
}
const _hoisted_7 = { class: "tw-mt-0.5 tw-text-sm tw-font-medium tw-text-slate-900" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = {
  key: 2,
  class: "tw-text-slate-500"
}
const _hoisted_11 = {
  key: 1,
  class: "tw-rounded-xl tw-border tw-border-slate-200/70 tw-bg-white/50 tw-p-2.5"
}
const _hoisted_12 = { class: "tw-mt-0.5 tw-text-sm tw-font-medium tw-text-slate-900" }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = {
  key: 1,
  class: "tw-text-slate-500"
}
const _hoisted_15 = { class: "tw-mt-3 tw-grid tw-grid-cols-1 sm:tw-grid-cols-4 tw-gap-2" }
const _hoisted_16 = { class: "tw-rounded-xl tw-border tw-border-slate-200/70 tw-bg-white/50 tw-p-2.5" }
const _hoisted_17 = { class: "tw-mt-0.5 tw-text-sm tw-font-medium tw-text-slate-900" }
const _hoisted_18 = { key: 0 }
const _hoisted_19 = {
  key: 1,
  class: "tw-text-slate-500"
}
const _hoisted_20 = { class: "tw-rounded-xl tw-border tw-border-slate-200/70 tw-bg-white/50 tw-p-2.5" }
const _hoisted_21 = { class: "tw-mt-0.5 tw-text-sm tw-font-medium tw-text-slate-900" }
const _hoisted_22 = { key: 0 }
const _hoisted_23 = {
  key: 1,
  class: "tw-text-slate-500"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_ContainerReeferDetailsEditModal = _resolveComponent("ContainerReeferDetailsEditModal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[3] || (_cache[3] = _createElementVNode("h2", { class: "tw-text-base tw-font-semibold tw-text-slate-900" }, "Reefer details", -1)),
      (_ctx.editable)
        ? (_openBlock(), _createBlock(_component_Button, {
            key: 0,
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isEditReeferDetailsModalOpen = true)),
            icon: "pen-to-square",
            title: "Edit reefer details",
            "aria-label": "Edit reefer details"
          }))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("dl", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _cache[4] || (_cache[4] = _createElementVNode("dt", { class: "tw-text-xs tw-font-medium tw-uppercase tw-tracking-wide tw-text-slate-500" }, "Genset: Needed", -1)),
        _createElementVNode("dd", _hoisted_5, _toDisplayString(_ctx.container.isGensetRequired ? 'Yes' : 'No'), 1)
      ]),
      (_ctx.container.isGensetRequired)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _cache[5] || (_cache[5] = _createElementVNode("dt", { class: "tw-text-xs tw-font-medium tw-uppercase tw-tracking-wide tw-text-slate-500" }, "Genset: Approved by shipline", -1)),
            _createElementVNode("dd", _hoisted_7, [
              (_ctx.container.isGensetApprovedByShipline === true)
                ? (_openBlock(), _createElementBlock("span", _hoisted_8, "Yes"))
                : (_ctx.container.isGensetApprovedByShipline === false)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_9, "No"))
                  : (_openBlock(), _createElementBlock("span", _hoisted_10, "—"))
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.container.isGensetRequired)
        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
            _cache[6] || (_cache[6] = _createElementVNode("dt", { class: "tw-text-xs tw-font-medium tw-uppercase tw-tracking-wide tw-text-slate-500" }, "Genset Number", -1)),
            _createElementVNode("dd", _hoisted_12, [
              (_ctx.container.gensetNumber)
                ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(_ctx.container.gensetNumber), 1))
                : (_openBlock(), _createElementBlock("span", _hoisted_14, "—"))
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("dl", _hoisted_15, [
      _createElementVNode("div", _hoisted_16, [
        _cache[7] || (_cache[7] = _createElementVNode("dt", { class: "tw-text-xs tw-font-medium tw-uppercase tw-tracking-wide tw-text-slate-500" }, "Genset Temperature", -1)),
        _createElementVNode("dd", _hoisted_17, [
          (_ctx.enteredTemperatureLabel)
            ? (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString(_ctx.enteredTemperatureLabel) + " (" + _toDisplayString(_ctx.convertedTemperatureHint) + ")", 1))
            : (_openBlock(), _createElementBlock("span", _hoisted_19, "—"))
        ])
      ]),
      _createElementVNode("div", _hoisted_20, [
        _cache[8] || (_cache[8] = _createElementVNode("dt", { class: "tw-text-xs tw-font-medium tw-uppercase tw-tracking-wide tw-text-slate-500" }, "Genset Vents", -1)),
        _createElementVNode("dd", _hoisted_21, [
          (_ctx.hasVentsOpenPercent)
            ? (_openBlock(), _createElementBlock("span", _hoisted_22, _toDisplayString(_ctx.container.gensetVentsOpenPercent) + "% open", 1))
            : (_openBlock(), _createElementBlock("span", _hoisted_23, "—"))
        ])
      ])
    ]),
    _createVNode(_component_ContainerReeferDetailsEditModal, {
      isOpen: _ctx.isEditReeferDetailsModalOpen,
      "onUpdate:isOpen": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.isEditReeferDetailsModalOpen) = $event)),
      container: _ctx.container,
      onSaved: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('saved', $event)))
    }, null, 8, ["isOpen", "container"])
  ]))
}